
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Critical = props => {
  const modClassName = props.className ? props.className + ' fe_c_icon--critical-solid' : ' fe_c_icon--critical-solid';

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g>
          <g>
            <path d="M11.2,3.5,1.3,20.2a1.3,1.3,0,0,0,1.2,2H22.4a1.4,1.4,0,0,0,1.3-2L13.7,3.5A1.4,1.4,0,0,0,11.2,3.5Z" className="fe_c_icon__icon fe_c_icon__icon--secondary"></path>
            <g className="fe_c_icon__icon fe_c_icon__icon--invert">
              <polygon points="13.1 15.8 13.5 10 11.5 10 11.9 15.8 13.1 15.8"></polygon>
              <path d="M12.5,17.2a1.1,1.1,0,0,0,0,2.2,1.1,1.1,0,1,0,0-2.2Z"></path>
            </g>
          </g>
        </g>
      </g>
    </IconBase>);
};

Critical.defaultProps = {
  title: 'Critical',
};

export default Critical;
